module.exports = __webpack_public_path__ + "static/img/public_logo.537d0d7c.png";